var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 290,
    viewBox: "0 0 252 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.602 273.603C194.971 273.603 251.205 217.369 251.205 148.001C251.205 78.6326 194.971 22.3984 125.602 22.3984C56.2341 22.3984 0 78.6326 0 148.001C0 217.369 56.2341 273.603 125.602 273.603Z",
    fill: "url(#paint0_linear_2818_6400)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2818_6400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.612 94.4102H53.5883C48.9638 94.4102 45.2148 98.1591 45.2148 102.784V278.627C45.2148 283.252 48.9638 287.001 53.5883 287.001H197.612C202.237 287.001 205.986 283.252 205.986 278.627V102.784C205.986 98.1591 202.237 94.4102 197.612 94.4102Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.855 119.531H65.3132C62.5384 119.531 60.2891 121.781 60.2891 124.555C60.2891 127.33 62.5384 129.579 65.3132 129.579H108.855C111.63 129.579 113.879 127.33 113.879 124.555C113.879 121.781 111.63 119.531 108.855 119.531Z",
    fill: "#B4DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139 141.301H65.3132C62.5384 141.301 60.2891 143.55 60.2891 146.325C60.2891 149.1 62.5384 151.349 65.3132 151.349H139C141.775 151.349 144.024 149.1 144.024 146.325C144.024 143.55 141.775 141.301 139 141.301Z",
    fill: "#DFEAFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.855 164.75H65.3132C62.5384 164.75 60.2891 166.999 60.2891 169.774C60.2891 172.549 62.5384 174.798 65.3132 174.798H108.855C111.63 174.798 113.879 172.549 113.879 169.774C113.879 166.999 111.63 164.75 108.855 164.75Z",
    fill: "#B4DAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139 186.52H65.3132C62.5384 186.52 60.2891 188.769 60.2891 191.544C60.2891 194.318 62.5384 196.568 65.3132 196.568H139C141.775 196.568 144.024 194.318 144.024 191.544C144.024 188.769 141.775 186.52 139 186.52Z",
    fill: "#DFEAFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.855 209.965H65.3132C62.5384 209.965 60.2891 212.214 60.2891 214.989C60.2891 217.764 62.5384 220.013 65.3132 220.013H108.855C111.63 220.013 113.879 217.764 113.879 214.989C113.879 212.214 111.63 209.965 108.855 209.965Z",
    fill: "#B4DAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139 231.734H65.3132C62.5384 231.734 60.2891 233.984 60.2891 236.758C60.2891 239.533 62.5384 241.783 65.3132 241.783H139C141.775 241.783 144.024 239.533 144.024 236.758C144.024 233.984 141.775 231.734 139 231.734Z",
    fill: "#DFEAFB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2818_6400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.612 9H53.5883C48.9638 9 45.2148 12.7489 45.2148 17.3735V67.6145C45.2148 72.239 48.9638 75.988 53.5883 75.988H197.612C202.237 75.988 205.986 72.239 205.986 67.6145V17.3735C205.986 12.7489 202.237 9 197.612 9Z",
    fill: "#1485FD"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.855 27.4219H65.3132C62.5384 27.4219 60.2891 29.6712 60.2891 32.446C60.2891 35.2207 62.5384 37.4701 65.3132 37.4701H108.855C111.63 37.4701 113.879 35.2207 113.879 32.446C113.879 29.6712 111.63 27.4219 108.855 27.4219Z",
    fill: "#B4DAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139 49.1914H65.3132C62.5384 49.1914 60.2891 51.4408 60.2891 54.2155C60.2891 56.9902 62.5384 59.2396 65.3132 59.2396H139C141.775 59.2396 144.024 56.9902 144.024 54.2155C144.024 51.4408 141.775 49.1914 139 49.1914Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2818_6400",
    x: 39.2148,
    y: 85.4102,
    width: 172.77,
    height: 204.59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2818_6400"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2818_6400",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2818_6400",
    x: 39.2148,
    y: 0,
    width: 172.77,
    height: 78.9883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2818_6400"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2818_6400",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2818_6400",
    x1: 125.602,
    y1: 22.3984,
    x2: 125.602,
    y2: 273.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/Empty.82bbd0dc59659a0ba14f99f4443d21d4.svg";
export { ForwardRef as ReactComponent };